module.exports = __webpack_public_path__ + "img/壁挂直流桩.59fa5ba6.png";